import React from "react";
import { usePagination } from "@material-ui/lab/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import { map } from "ramda";
import PageIcon from "@material-ui/icons/FiberManualRecord";
import PreviousIcon from "@material-ui/icons/KeyboardArrowLeft";
import NextIcon from "@material-ui/icons/KeyboardArrowRight";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(theme => ({
  pageButton: {
    padding: theme.spacing(1),
  },

  pageIcon: {
    fontSize: ".75rem",
    lineHeight: "1.0rem",
    color: theme.palette.disabled,
  },

  selectedPageIcon: {
    fontSize: ".75rem",
    lineHeight: "1.0rem",
    color: theme.palette.primary.darker,
  },

  navButton: {
    padding: theme.spacing(1),
    color: theme.palette.primary.darker,
  },

  navIcon: {
    fontSize: "2.75rem",
    lineHeight: "1.0rem",
  },

  disabled: {
    color: theme.palette.disabled,
  },
}));

const DotPagination = ({
  totalCount,
  itemsPerPage = 4,
  page,
  onPageSelect,
}) => {
  const classes = useStyles();
  const { items } = usePagination({
    count: Math.ceil(totalCount / itemsPerPage) || 1,
    onChange: (event, page) => onPageSelect(page - 1),
    page: page + 1,
  });

  return (
    <nav>
      <Grid container justify="center" alignItems="center">
        {map(({ page, type, selected, ...item }) => {
          let children = null;

          if (type === "start-ellipsis" || type === "end-ellipsis") {
            children = "…";
          } else if (type === "page") {
            children = (
              <IconButton
                size="small"
                classes={{
                  sizeSmall: classes.pageButton,
                }}
                aria-label="page"
                {...item}
              >
                <PageIcon
                  classes={{
                    root: selected
                      ? classes.selectedPageIcon
                      : classes.pageIcon,
                  }}
                />
              </IconButton>
            );
          } else {
            children =
              type === "previous" ? (
                <IconButton
                  classes={{
                    root: classes.navButton,
                    disabled: classes.disabled,
                  }}
                  aria-label="previous-page"
                  {...item}
                >
                  <PreviousIcon
                    classes={{ root: classes.navIcon }}
                    fontSize="large"
                  />
                </IconButton>
              ) : (
                <IconButton
                  classes={{
                    root: classes.navButton,
                    disabled: classes.disabled,
                  }}
                  aria-label="next-page"
                  {...item}
                >
                  <NextIcon
                    classes={{ root: classes.navIcon }}
                    fontSize="large"
                  />
                </IconButton>
              );
          }

          return (
            <Grid item key={`${type}-${page}`}>
              {children}
            </Grid>
          );
        }, items)}
      </Grid>
    </nav>
  );
};

export default DotPagination;
